var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"right"},[_c('div',{staticClass:"box"},[_vm._t("default")],2),_c('p',{staticClass:"tel"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }